import { type Dispatch, type SetStateAction } from 'react';

import { DataGaEventPrefix } from './types';
import type { CodeConfirmData } from 'app/widgets/CodeConfirmation/types';

import { httpApiService, ResponseStatus } from 'app/api';
import { AuthModalQuery } from 'app/modules/Signing/utils/auth-modals-query';

import { CodeError } from './constants';

type reGetCodeProps = {
  reSendData: {
    config?: AxiosRequestConfig;
    url: string;
    data: Record<string, string>;
  };
  changeData: Dispatch<SetStateAction<CodeConfirmData>>;
};

export function reGetCode({
  reSendData,
  changeData,
}: reGetCodeProps) {
  httpApiService.post(reSendData.url, reSendData.data, reSendData.config)
    .then((res) => {
      changeData((prevState) => ({ ...prevState, ...res.data }));
    })
    .catch(({ response }) => {
      const { serverTime, resendDate, status } = response.data;

      if (status === ResponseStatus.TOO_MANY_REQUESTS) {
        changeData((prevState) => ({ ...prevState, resendDate, serverTime }));
      }
    });
}

export function getErrorMessage(error: CodeError) {
  return Object.values(CodeError).includes(error) ? error : CodeError.SOMETHING_WRONG;
}

export const getDataGaEventBySearchParams = (search: string) => {
  if (search.includes(AuthModalQuery.RESTORE_PASSWORD)) {
    return getEvents(DataGaEventPrefix.PASSWORD_RESET);
  }

  if (search.includes(AuthModalQuery.SIGN)) {
    return getEvents(DataGaEventPrefix.SIGN_IN);
  }

  return getEvents();
};

function getEvents(prefix?: DataGaEventPrefix) {
  if (!prefix) {
    return {};
  }

  return {
    resentDataEvent: `${prefix}CodeResent`,
    changeDataEvent: `${prefix}NumberChange`,
  };
}
